import { layouts, colors, font, devices, spacing } from '../../config/theme'
import {
  widthHeight100,
  marginPadding0,
  hidden,
  asPx,
  scrollY
} from '../../utils/jss-utils'

const style = {}

style.base = {
  // maxWidth: asPx(layouts.sidebar.width),
  maxWidth: '100%',
  opacity: '1',
  flexGrow: 2,
  ...scrollY,
  '& ul': {
    marginLeft: '0'
  },
  '& li': {
    '& div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '60px'
    },
    '& .level-1': {
      paddingLeft: '25px'
    },
    '& .level-2': {
      paddingLeft: '50px'
    },
    '& .level-3': {
      paddingLeft: '75px'
    },
    '& .level-4': {
      paddingLeft: '100px'
    },
    '& span:nth-child(2)': {
      float: 'right'
    },
    '& img': {
      width: '20px',
      height: '20px',
      transition: 'all .2s'
    },
    transition: 'all .2s',
    '&:hover': {
      cursor: 'pointer',
      '@media only screen and (min-width: 1010px)': {
        color: colors.black,
        '&> div': {
          '& img': {
            filter: 'invert(0)'
          }
        }
      },
      '@media only screen and (max-width: 1009px)': {
        color: `${colors.blue}`,
        '&> div': {
          '& img': {
            filter: 'invert(40%) sepia(20%) saturate(10000%) hue-rotate(225deg)'
          }
        }
      }
    },
    fontSize: font.sizes.small,
    '@media only screen and (max-width: 1009px)': {
      fontSize: '16px' // font.sizes.medium
    },
    '@media only screen and (min-width: 1010px)': {
      fontSize: '16px' // font.sizes.medium
    }
  },
  '&> ul': {
    ...marginPadding0,
    marginTop: '-15px',
    '&> li': {
      '&:last-child': {
        '@media only screen and (max-width: 1009px)': {
          borderBottom: `1px solid ${colors.lightestGray}` // add bottom border to top menu on mobile
        }
      },
      fontSize: font.sizes.medium,
      '&> div': {
        height: '85px !important',
        '@media only screen and (max-width: 1009px)': {
          height: '70px !important'
        },
        paddingLeft: '0px !important',
        '& .textIcon': {
          '@media only screen and (min-width: 1010px)': {
            fontSize: font.sizes.extraSmall
          },
          '@media only screen and (max-width: 1009px)': {
            fontSize: font.sizes.smallMedium
          }
        }
      },
      '& li': {
        borderTop: `1px solid ${colors.lightestGray}`
      }
    }
  }
}

style.bottomBorder = {
  borderBottom: `1px solid ${colors.lightestGray}`
}

style.hideOnMobile = {}
style.hideOnDesktop = {}

style.active = {
  color: `${colors.black} !important`,
  '@media only screen and (max-width: 1009px)': {
    color: `${colors.blue} !important`,
    '& img': {
      filter: 'invert(40%) sepia(20%) saturate(10000%) hue-rotate(225deg)'
    }
  },
  '&> img': {
    filter: 'invert(0) !important'
  }
}

style.disabled = {
  '@media only screen and (min-width: 1010px)': {
    color: `${colors.lightGray} !important`,
    '& img': {
      filter: 'invert(.7) !important'
    },
    '&:hover': {
      cursor: 'not-allowed !important',
      color: `${colors.lightGray} !important`,
      '& img': {
        filter: 'invert(.7) !important'
      }
    }
  },
  '@media only screen and (max-width: 1009px)': {
    color: `#c7c7c7 !important`,
    '& img': {
      filter: 'invert(.8) !important'
    },
    '&:hover': {
      cursor: 'not-allowed !important',
      color: `#c7c7c7 !important`,
      '& img': {
        filter: 'invert(.8) !important'
      }
    }
  }
}

style.inactive = {
  '@media only screen and (min-width: 1010px)': {
    color: `${colors.lightGray}`,
    '& img': {
      filter: 'invert(.7)'
    }
  },
  '@media only screen and (max-width: 1009px)': {
    color: `${colors.black}`,
    '& img': {
      filter: 'invert(0)'
    }
  }
}

style.base[devices.mobile] = {
  // ...widthHeight100,
  width: 'calc(100% - 50px)',
  height: 'calc(100% - 70px) !important',
  bottom: '70px',
  top: '0',
  padding: '0 !important',
  position: 'absolute',
  '& li': {
    borderTop: `1px solid ${colors.lightestGray}`,
    fontWeight: '400'
  },
  '& .level-0': {
    fontWeight: '500'
  }
}

style.base[devices.desktop] = {
  paddingLeft: '40px',
  paddingRight: '40px'
}

style.hideOnMobile[devices.mobile] = { ...hidden }
style.hideOnDesktop[devices.desktop] = { ...hidden }

export default style
